import React, { FC } from 'react';
import cn from 'classnames';
import { splitFirstWord } from '@/modules/tariff/shared/helpers';
import { TariffOptionIconsPurple, TariffOptionIconsWhite } from '@/modules/tariff/shared/constants';
import { InfinityIcon, InfinityIconWhite } from '@/shared/assets/svg';
import { TariffCardOptionProps } from './tariff-card-option.types';
import styles from './tariff-card-option.module.scss';

const TariffCardOption: FC<TariffCardOptionProps> = ({ icon, value='', text='', from, purple, className, boldFistWord }) => {
  const infinityIcon = purple ? <InfinityIcon /> : <InfinityIconWhite />;

  return (
    <div className={cn(styles.container, { [styles.purple]: purple })}>
      {purple ? TariffOptionIconsPurple[icon] : TariffOptionIconsWhite[icon]}
      <div className={styles.row}>
        {from && <span className={styles.priceFrom}>от </span>}
        {value && (
          <span className={cn(styles.numberOption, { [styles.numberOption__unlimited]: icon === 'unlimited' })}>
            {value === '∞' ? infinityIcon : value}
          </span>
        )}
        {text && (
          <span className={cn(styles.textOption, className)}>
            {boldFistWord && <span className={styles.textOption__bold}> {splitFirstWord(text)[0]} </span>}
            {boldFistWord ? splitFirstWord(text)[1] : text}
          </span>
        )}
      </div>
    </div>
  );
};
export default TariffCardOption;
